import { render, staticRenderFns } from "./LessonExit.vue?vue&type=template&id=2b664a73&scoped=true&"
import script from "./LessonExit.vue?vue&type=script&lang=js&"
export * from "./LessonExit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/exit.css?vue&type=style&index=0&id=2b664a73&prod&scoped=true&lang=css&"
import style1 from "./LessonExit.vue?vue&type=style&index=1&id=2b664a73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b664a73",
  null
  
)

export default component.exports